var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBarsgroup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 151 63",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "51.1947092%",
    y1: "34.2468088%",
    x2: "42.2810199%",
    y2: "112.103348%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C32118",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B32318",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.2864092%",
    y1: "101.944488%",
    x2: "49.9924216%",
    y2: "11.1636423%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BB22D",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6C714",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "48.7022471%",
    y1: "82.5865031%",
    x2: "57.7698319%",
    y2: "3.14986854%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8C500",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEDB00",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "102.893207%",
    y1: "9.48979967%",
    x2: "20.9070106%",
    y2: "99.8885219%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CBDEB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2DA1DB",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frontend",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "main_01",
    transform: "translate(-85.000000, -2651.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Footer",
    transform: "translate(4.000000, 2570.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo/M",
    transform: "translate(81.000000, 81.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x21__2_",
    transform: "translate(0.000000, 22.646154)",
    fill: "#4F4949"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.84093389,9.77980718 L15.8593399,9.77980718 C18.9568673,9.77980718 21.5587902,12.3153127 21.5587902,15.4545101 C21.5587902,16.0582019 21.5587902,17.5070622 21.5587902,18.2314924 C21.5587902,21.3706898 18.9568673,23.9061953 15.8593399,23.9061953 L3.84093389,23.9061953 L0,23.9061953 C0,16.420417 0,7.96873177 0,0.482953441 L20.0719771,0.482953441 L20.0719771,4.22584261 L3.84093389,4.22584261 L3.84093389,9.77980718 Z M3.84093389,13.5226963 L3.84093389,20.0425678 L15.8593399,20.0425678 C16.8505487,20.0425678 17.7178563,19.1973993 17.7178563,18.110754 C17.7178563,17.3863239 17.7178563,16.0582019 17.7178563,15.3337717 C17.7178563,14.2471265 16.8505487,13.401958 15.8593399,13.401958 L3.84093389,13.5226963 L3.84093389,13.5226963 Z",
    id: "_168854320_1_",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3662061,14.3678649 L69.3846122,14.3678649 C72.4821395,14.3678649 75.0840625,11.8323593 75.0840625,8.69316193 C75.0840625,8.08947013 75.0840625,6.64060981 75.0840625,5.91617965 C75.0840625,2.77698228 72.4821395,0.24147672 69.3846122,0.24147672 L57.3662061,0.24147672 L53.5252723,0.24147672 C53.5252723,7.84799341 53.5252723,16.0582019 53.5252723,23.6647186 L57.3662061,23.6647186 C57.3662061,20.6462596 57.3662061,17.5070622 57.3662061,14.3678649 Z M57.3662061,10.6249757 L57.3662061,4.10510425 L69.3846122,4.10510425 C70.3758209,4.10510425 71.2431286,4.95027277 71.2431286,6.03691801 C71.2431286,6.76134817 71.2431286,8.08947013 71.2431286,8.81390029 C71.2431286,9.90054554 70.3758209,10.7457141 69.3846122,10.7457141 L57.3662061,10.6249757 L57.3662061,10.6249757 Z",
    id: "_168854248_1_",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2439521,0.362215081 L100.112083,0.362215081 L100.112083,4.10510425 L85.2439521,4.10510425 C84.2527434,4.10510425 83.3854357,4.95027277 83.3854357,6.03691801 C83.3854357,8.93463865 83.3854357,15.3337717 83.3854357,18.2314924 C83.3854357,19.3181376 84.2527434,20.1633062 85.2439521,20.1633062 L85.2439521,20.1633062 L100.112083,20.1633062 L100.112083,23.9061953 C94.412633,23.9061953 90.9434024,23.9061953 85.2439521,23.9061953 C82.1464248,23.9061953 79.5445018,21.3706898 79.5445018,18.2314924 C79.5445018,10.383499 79.5445018,13.8849114 79.5445018,6.03691801 C79.5445018,2.89772064 82.0225237,0.362215081 85.2439521,0.362215081 Z",
    id: "_168854176_1_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7986247,4.58805769 L41.1351629,13.6434347 L32.3381853,13.6434347 L36.7986247,4.58805769 Z M30.4796689,17.2655855 L42.9936793,17.2655855 L45.8434045,23.785457 L50.0560416,23.785457 L38.9049433,0.362215081 C37.4181301,0.362215081 36.0552181,0.362215081 34.568405,0.362215081 L23.4173066,23.785457 L27.6299438,23.785457 L30.4796689,17.2655855 Z",
    id: "_168852856_1_",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(53.277470, 27.769823)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2486257,7.84799341 L19.3285705,7.84799341 C20.8153837,7.84799341 22.0543946,6.64060981 22.0543946,5.19174949 C22.0543946,4.95027277 22.0543946,3.74288917 22.0543946,3.50141245 C22.0543946,2.05255212 20.8153837,0.845168521 19.3285705,0.845168521 L14.2486257,0.845168521 L12.018406,0.845168521 C12.018406,4.34658097 12.018406,8.45168521 12.018406,11.9530977 L14.2486257,11.9530977 C14.2486257,10.6249757 14.2486257,9.29685373 14.2486257,7.84799341 Z M14.2486257,5.79544129 L14.2486257,3.13919736 L18.8329662,3.13919736 C19.3285705,3.13919736 19.7002738,3.50141245 19.7002738,3.98436589 C19.7002738,4.34658097 19.7002738,4.58805769 19.7002738,4.82953441 C19.7002738,5.31248785 19.3285705,5.67470293 18.8329662,5.67470293 L14.2486257,5.67470293 L14.2486257,5.79544129 Z",
    id: "_168854464_1_",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_168852880_1_",
    points: "0.247802186 0.965906881 9.91208745 0.965906881 9.91208745 3.13919736 2.47802186 3.13919736 2.47802186 12.073836 0.247802186 12.073836"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6475263,12.073836 L28.0016471,12.073836 C29.240658,10.0212839 34.568405,1.08664524 34.568405,1.08664524 L32.0903831,1.08664524 L28.7450536,7.00282489 L25.1519219,1.08664524 L22.6739001,1.08664524 L27.3821416,9.05537701 C27.1343394,9.41759209 26.1431307,11.3494059 25.6475263,12.073836 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "35.8074159 0.965906881 35.8074159 12.073836 37.9137345 12.073836 37.9137345 3.13919736 44.6043935 3.13919736 44.6043935 10.2627606 44.6043935 12.073836 46.8346132 12.073836 46.8346132 0.965906881"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(115.480519, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2635721,61.8854384 C15.4983963,62.0107437 15.4983963,62.2613544 15.2635721,62.3866597 L14.3242754,62.887881 C14.0894512,63.0131863 13.6198028,63.0131863 13.3849786,62.887881 L0.469648373,55.9960885 C0.234824187,55.8707832 0,55.4948672 0,55.2442566 L0,50.7332652 C0,50.4826545 0.234824187,50.3573492 0.35223628,50.4826545 L15.2635721,61.8854384 Z",
    id: "Path",
    fill: "#4F4949"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_168854848_6_",
    transform: "translate(4.536793, 0.000000)",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.85218024,15.146555 C6.61735605,15.2718603 6.38253186,15.6477763 6.26511977,15.8983869 L0.0422788251,50.1067386 C0.0422788251,50.3573492 0.159690918,50.7332652 0.394515105,50.9838758 L3.09499325,53.1140662 C3.32981744,53.2393715 3.56464162,53.2393715 3.79946581,52.9887609 L30.6868352,0.36052758 C30.8042473,0.109916945 30.6868352,-0.0153883723 30.452011,0.109916945 L6.85218024,15.146555 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_168854776_6_",
    transform: "translate(0.000000, 17.449045)",
    fill: "url(#linearGradient-2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.469648373,5.21582933 C0.234824187,5.34113465 0.117412093,5.7170506 0.117412093,6.09296655 L0.117412093,29.2744503 C0.117412093,29.5250609 0.35223628,29.9009769 0.469648373,30.1515875 L2.34824187,31.529946 C2.58306605,31.6552513 2.81789024,31.6552513 2.81789024,31.2793353 L7.51437397,0.328921953 C7.51437397,0.0783113186 7.39696188,-0.0469939988 7.16213769,0.0783113186 L0.469648373,5.21582933 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_168854704_6_",
    transform: "translate(9.392967, 21.411821)",
    fill: "url(#linearGradient-3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.70447256,32.9552985 C0.587060466,33.2059091 0.587060466,33.5818251 0.821884653,33.7071304 L3.63977489,35.8373208 C3.87459908,35.9626261 4.22683536,35.9626261 4.46165954,35.8373208 L23.5998307,18.545187 C23.8346549,18.2945763 23.952067,17.9186604 23.8346549,17.6680498 L19.1381712,0.375915952 C19.0207591,0.125305317 18.903347,0.125305317 18.7859349,0.375915952 L0.70447256,32.9552985 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_168854632_6_",
    transform: "translate(15.263572, 45.016215)",
    fill: "url(#linearGradient-4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0247535,0.328921953 C16.9073414,0.0783113186 16.6725172,-0.0469939988 16.4376931,0.203616636 L0.234824187,13.6112856 C8.83113027e-14,13.7365909 8.83113027e-14,14.1125069 0.234824187,14.2378122 L2.11341768,15.741476 C2.34824187,15.8667813 2.70047815,15.9920866 2.93530233,15.8667813 L17.3769898,9.35090481 C17.611814,9.22559949 17.7292261,8.84968354 17.611814,8.5990729 L17.0247535,0.328921953 Z",
    id: "Path"
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarsgroup);
export default __webpack_public_path__ + "static/media/barsgroup.08ea21e0952c790edcd4cb8aff2a7be4.svg";
export { ForwardRef as ReactComponent };